var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4885_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38314 0 0 5.38314 0 12C0 18.6169 5.38314 24 12 24C18.6169 24 24 18.6169 24 12C24 5.38314 18.6169 0 12 0ZM12 22.2857C6.32848 22.2857 1.71429 17.6715 1.71429 12C1.71429 6.32848 6.32848 1.71429 12 1.71429C17.6715 1.71429 22.2857 6.32848 22.2857 12C22.2857 17.6715 17.6715 22.2857 12 22.2857Z",
    fill: "#5C5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6771 8.32246C15.3424 7.98769 14.7997 7.98769 14.4649 8.32246L11.9998 10.7876L9.53455 8.32236C9.19979 7.9876 8.65712 7.9876 8.32236 8.32236C7.9876 8.65712 7.9876 9.19979 8.32236 9.53455L10.7876 11.9998L8.32236 14.465C7.9876 14.7998 7.9876 15.3425 8.32236 15.6772C8.48969 15.8446 8.70912 15.9283 8.92846 15.9283C9.14779 15.9283 9.36712 15.8446 9.53455 15.6772L11.9998 13.212L14.465 15.6772C14.6324 15.8446 14.8518 15.9283 15.0711 15.9283C15.2905 15.9283 15.5098 15.8446 15.6772 15.6772C16.012 15.3425 16.012 14.7998 15.6772 14.465L13.212 11.9998L15.6772 9.53455C16.0119 9.19988 16.0119 8.65712 15.6771 8.32246Z",
    fill: "#5C5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4885_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCancel);
export default __webpack_public_path__ + "static/media/circleCancel.ca0638ccb446712b3b62561a8a6118d9.svg";
export { ForwardRef as ReactComponent };